import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthenticationService } from './services/authentication.service';


@Injectable({
  providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
        const currentUser = this.authenticationService.currentTokenValue;
        const isApiUrl = request.url.startsWith(environment.baseUrl);

        if (currentUser && isApiUrl) {
            request = request.clone({
                setHeaders: {
                  'X-Auth-Token': `${currentUser.token}`
                }
            });
        }

        return next.handle(request);
    }
}
